import { PlusIcon } from '@heroicons/react/24/outline';
import PropTypes from 'prop-types';

import { aisleContentStyles } from 'features/shop/AisleContent';
import ProductCardV2 from 'features/shop/ProductCardV2';
import MaxLoyaltyPointsSpendAlert from 'pages/shop/ShopWithPoints/MaxLoyaltyPointsSpendAlert';

function RedeemedGiftsTab({ selections, setCurrentTab, showMaxLoyaltyPointsSpendAlert }) {
    const perkSelections = selections?.selected?.filter((selection) => selection?.isPerk);

    return (
        <>
            {showMaxLoyaltyPointsSpendAlert && <MaxLoyaltyPointsSpendAlert />}
            <p className="text-body-md my-20">
                You may edit redeemed items until your shopping window closes. Gift items will be shipped with your
                order!
            </p>

            <div className={aisleContentStyles.aisleSectionV2}>
                {perkSelections.map((product, count) => {
                    const productKey = `${product.id}-${count}`;
                    return (
                        <ProductCardV2
                            data={product}
                            key={productKey}
                            metaData={{
                                aisleID: null,
                                carouselID: null,
                                carouselName: null,
                                customAisle: true,
                                isCarouselModalCard: false,
                                searchRecommendation: false,
                            }}
                            variant="PERK-REDEEMED"
                        />
                    );
                })}
                <button
                    type="button"
                    onClick={() => setCurrentTab('tab1')}
                    className="mb-60 flex min-h-[180px] cursor-pointer items-center justify-center rounded-md border border-dashed border-kale md:mb-0 md:min-h-[300px] if:border-beet"
                >
                    <PlusIcon className="w-20 stroke-[3px]" />
                </button>
            </div>
        </>
    );
}

RedeemedGiftsTab.propTypes = {
    selections: PropTypes.shape({ selected: PropTypes.arrayOf(PropTypes.shape({ isPerk: PropTypes.bool })) })
        .isRequired,
    setCurrentTab: PropTypes.func.isRequired,
    showMaxLoyaltyPointsSpendAlert: PropTypes.bool,
};
RedeemedGiftsTab.defaultProps = {
    showMaxLoyaltyPointsSpendAlert: false,
};

export default RedeemedGiftsTab;
